import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VariableBenefitAccountDetails } from '../../../../../../models/transactions/variable-benefit-account-details';

@Component({
  selector: 'app-vb-payment-change-age-for-minimum-calculation',
  templateUrl: './vb-payment-change-age-for-minimum-calculation.component.html',
  styleUrls: ['./vb-payment-change-age-for-minimum-calculation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeAgeForMinimumCalculationComponent {
  @Input({ required: true }) accountDetails!: VariableBenefitAccountDetails[];

  public trackByIndex(index: number): number {
    return index;
  }
}
